export const CONV_OPERATION = {
  DELETE: 'delete',
  ISPINNED: 'ispinned',
  DISPINNED: 'dispinned',
  MUTE: 'mute',
  NOTMUTE: 'notmute'
}

export const CONV_CREATE_TYPE = {
  TYPEC2C: 'isC2C',
  TYPEGROUP: 'isGroup',
  JOINGROUP: 'joinGroup'
}

export const CHAT_MSG_CUSTOM_TYPE = {
  SERVICE: 'consultion',
  EVALUATE: 'evaluation',
  LINK: 'text_link',
  CALL: 1,
  ORDER: 'order'
}

export const DIALOG_CONTENT = {
  USERLIST: 'userList',
  GROUPINFORMATION: 'groupInformation'
}

export const EMOJI_TYPE = {
  BASIC: 'basic',
  BIG: 'big',
  CUSTOM: 'CUSTOM'
}

export const CONTACT_INFO_LABEL_POSITION = {
  LEFT: 'left',
  TOP: 'top'
}

export const CONTACT_INFO_MORE_EDIT_TYPE = {
  INPUT: 'input',
  TEXTAREA: 'textarea',
  SWITCH: 'switch'
}

export const CONTACT_INFO_BUTTON_TYPE = {
  SUBMIT: 'submit',
  CANCEL: 'cancel'
}
